import { isEqual } from 'lodash/fp';

import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import { UserSession, UserSessionStatus } from 'dashboard/models/user-session';
import {
  UserSessionsActions,
  UserSessionsActionType,
  UserSessionsFilterParams,
} from 'dashboard/redux/actions/user-sessions';

export interface UserSessionsState
  extends Omit<TableState<UserSessionsFilterParams>, 'sortParams'> {
  userSessions: UserSession[];
}

const initialState: UserSessionsState = {
  userSessions: [],
  paginationParams: undefined,
  filters: {
    createdAtStart: undefined,
    createdAtEnd: undefined,
    userIds: [],
    status: UserSessionStatus.Active,
  },
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
};

export default (state: UserSessionsState = initialState, action: UserSessionsActions) => {
  switch (action.type) {
    case UserSessionsActionType.SetUserSessions: {
      return {
        ...state,
        userSessions: action.payload.userSessions,
        paginationParams: action.payload.paginationParams,
      };
    }

    case UserSessionsActionType.SetFilters: {
      const newFilters = {
        ...state.filters,
        ...action.payload.filters,
      };

      if (isEqual(newFilters, state.filters)) {
        return state;
      } else {
        return {
          ...state,
          filters: newFilters,
        };
      }
    }

    case UserSessionsActionType.SetPageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }

    case UserSessionsActionType.SetCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }

    default:
      return state;
  }
};
